var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5484 1.5C17.5484 0.671573 16.8552 0 16 0C15.1448 0 14.4516 0.671573 14.4516 1.5V14.1516C14.4516 14.3173 14.3173 14.4516 14.1516 14.4516H1.5C0.671573 14.4516 0 15.1448 0 16C0 16.8552 0.671573 17.5484 1.5 17.5484H14.1516C14.3173 17.5484 14.4516 17.6827 14.4516 17.8484V30.5C14.4516 31.3284 15.1448 32 16 32C16.8552 32 17.5484 31.3284 17.5484 30.5V17.8484C17.5484 17.6827 17.6827 17.5484 17.8484 17.5484H30.5C31.3284 17.5484 32 16.8552 32 16C32 15.1448 31.3284 14.4516 30.5 14.4516H17.8484C17.6827 14.4516 17.5484 14.3173 17.5484 14.1516V1.5Z",
    fill: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.2fad5881b4cfad15035fb895b8f4f7ed.svg";
export { ForwardRef as ReactComponent };